import { render, staticRenderFns } from "./CurrentSaleTable.vue?vue&type=template&id=0ea17e78&scoped=true"
import script from "./CurrentSaleTable.vue?vue&type=script&lang=js"
export * from "./CurrentSaleTable.vue?vue&type=script&lang=js"
import style0 from "./CurrentSaleTable.vue?vue&type=style&index=0&id=0ea17e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea17e78",
  null
  
)

export default component.exports